import React from 'react'
import { StripeProvider, Elements } from 'react-stripe-elements';
import Step1 from './Step1'
import Step2 from './Step2'
import Header from '../../Header'
import { buttons } from '../../../helpers/const'

class Index extends React.Component {
  constructor(props) {
    super(props);
    const { customer } = this.props;
    this.state = {
      currentStep: customer ? 2 : 1
    }
  }

  setStep = (step) => {
    this.setState({ currentStep: step })
  };

  render() {
    const { currentUser }  = this.props;
    const { currentStep } = this.state;

    return (
      <React.Fragment>
        <div className="flex flex-center flex-justify-center mh-100vh" style={{ paddingTop: '80px' }}>
          <Header
            buttonText={buttons.plan.text}
            buttonUrl={buttons.plan.url}
            currentUser={currentUser}
          />

          <div className="col-12 md-px3 mx-auto py-110 sm-py4" style={{ maxWidth: '1010px' }}>
            {currentStep === 1 &&
              <StripeProvider apiKey={this.props.stripe_key}>
                <Elements>
                  <Step1 {...this.props} />
                </Elements>
              </StripeProvider>
            }

            {currentStep === 2 &&
              <Step2
                setStep={this.setStep}
                {...this.props}
              />
            }
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Index
